import { render, staticRenderFns } from "./AlertCollection.vue?vue&type=template&id=974011b6&scoped=true&"
import script from "./AlertCollection.vue?vue&type=script&lang=js&"
export * from "./AlertCollection.vue?vue&type=script&lang=js&"
import style0 from "./AlertCollection.vue?vue&type=style&index=0&id=974011b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974011b6",
  null
  
)

export default component.exports